import { useContext, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import BorseContext from "../../context/borse";
import Icon from "../icon";
import BorseBoxWrapper from "./borse-box-wrapper";
import UserContext from "../../context/user";
import BorseDiscardRequestModal from "./borse-discard-request-modal";
import BorseSubmitRequestModal from "./borse-submit-request-modal";

const BorseStep4 = ({ discardModal, setDiscardModal }) => {
  const [submitModal, setSubmitModal] = useState(false);
  const { userProfile } = useContext(UserContext);
  const { labels, handlePrevious, currentRequest, setCurrentRequest } = useContext(BorseContext);
  const queryClient = useQueryClient();

  const handleSaveDraft = () => {
    setCurrentRequest();
    queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
  };

  const handleSubmit = () => setSubmitModal(true);

  return (
    <>
      <BorseBoxWrapper
        readOnly={!(currentRequest?.status === "DRAFT" || currentRequest === "new")}
      />
      {currentRequest?.status === "DRAFT" || currentRequest === "new" ? (
        <>
          <div className="form__buttons-wrapper">
            <div className="form__buttons form__buttons--space-between">
              <div className="form__buttons-container">
                <button className="link" type="button" onClick={handlePrevious}>
                  <Icon name="angle-down" />
                  {labels?.WELFARE_FORM_BTN_PREVIOUS || "Previous"}
                </button>
                <button
                  className="button secondary form__submit mobile-only"
                  onClick={handleSaveDraft}
                >
                  {labels?.WELFARE_FORM_BTN_SAVE_DRAFT || "Save draft"}
                </button>
              </div>
              <div className="form__buttons-container">
                <button
                  className="button secondary form__submit desktop-only"
                  onClick={handleSaveDraft}
                >
                  {labels?.WELFARE_FORM_BTN_SAVE_DRAFT || "Save draft"}
                </button>
                <button className="button primary form__submit" onClick={handleSubmit}>
                  {labels?.WELFARE_FORM_BTN_SEND || "Send"}
                </button>
              </div>
            </div>
          </div>
          <BorseDiscardRequestModal
            key={`discard-${!!discardModal}`}
            discardModal={discardModal}
            setDiscardModal={setDiscardModal}
            skipUpdate={true}
          />
          <BorseSubmitRequestModal
            show={submitModal}
            closeModal={() => setSubmitModal(false)}
            key={`submit-${!!submitModal}`}
          />
        </>
      ) : null}
    </>
  );
};

export default BorseStep4;
